export function getModelParams() {
  const {
    language,
    country,
    region,
    brand,
    carline,
    year,
    bodyStyle,
    continent
  } = window.appResources;

  return {
    lang: language,
    country,
    region,
    brand,
    carline,
    modelyear: year,
    bodystyle: bodyStyle,
    continent: continent ? continent : region
  };
}
